<template>
    <div v-separator-link="200">
        <div class="gcmcn-form-title">{{ entity ? 'Edit' : 'Add'}} entity</div>
        <div class="gcmcn-card">
            <el-form :model="form" :rules="rules" ref="form">
                <el-form-item class="gcmcn-form-input" prop="name">
                    <div class="gcmcn-form-label">Name</div>
                    <el-input
                        size="mini"
                        v-model="form.display_name"
                    ></el-input>
                </el-form-item>

                <el-form-item
                    v-if="userIsAtLeastAdmin || userIsEntityAdmin(entityUid)"
                    class="gcmcn-form-input"
                >
                    <div class="gcmcn-form-label">Globecast region</div>
                    <el-select
                        v-model="form.datacenter"
                        size="mini"
                        popper-class="gcmcn-popper"
                        filterable
                    >
                        <el-option
                            v-for="datacenter in filteredDatacenters"
                            :key="datacenter.uid"
                            :label="datacenter.name"
                            :value="datacenter.uid"
                        >
                        </el-option>
                        <el-option label="No region selected" :value="null"></el-option">
                    </el-select>
                </el-form-item>

                <el-form-item
                    v-if="userIsAtLeastAdmin || userIsEntityAdmin(entityUid)"
                    class="gcmcn-form-input"
                >
                    <div class="gcmcn-form-label">AWS dispatch region</div>
                    <el-select
                        v-model="form.aws_dispatch_region_uid"
                        size="mini"
                        popper-class="gcmcn-popper"
                        filterable
                    >
                        <el-option
                            v-for="region in awsregions"
                            :key="region.uid"
                            :label="region.display_name"
                            :value="region.uid"
                        >
                        </el-option>
                        <el-option label="No region selected" :value="null"></el-option">
                    </el-select>
                </el-form-item>

                <el-form-item class="gcmcn-form-input">
                    <div class="gcmcn-form-label">Max latency (zixi)</div>
                    <el-select
                        v-model="form.max_latency_ms"
                        size="mini"
                        popper-class="gcmcn-popper"
                    >
                        <el-option v-for="lat in $store.getters.sortedLatencies"
                            :key="lat.uid"
                            :label="`${lat.value_ms} ms (${lat.name})`"
                            :value="lat.value_ms"
                        >
                        </el-option>
                        <el-option label="/" :value="0"></el-option">
                    </el-select>
                </el-form-item>

                <el-form-item class="gcmcn-form-input">
                    <div class="gcmcn-form-label">Min latency (srt)</div>
                    <el-select
                        v-model="form.min_latency_ms"
                        size="mini"
                        popper-class="gcmcn-popper"
                    >
                        <el-option v-for="lat in $store.getters.sortedLatencies"
                            :key="lat.uid"
                            :label="`${lat.value_ms} ms (${lat.name})`"
                            :value="lat.value_ms"
                        >
                        </el-option>
                        <el-option label="/" :value="0"></el-option">
                    </el-select>
                </el-form-item>
                <el-form-item
                    class="gcmcn-form-input radio-input"
                    v-if="userIsAtLeastAdmin || userIsEntityAdmin(entityUid)"
                >
                    <div class="gcmcn-form-label">
                        Choose default feed redundancy
                    </div>
                    <el-radio
                        v-model="form.feed_redundancy_type"
                        label="1+0"
                    >
                        1+0 (MAIN only)
                    </el-radio>
                    <el-radio
                        v-model="form.feed_redundancy_type"
                        label="1+1"
                    >
                        1+1 (MAIN+BACKUP)
                    </el-radio>
                </el-form-item>
                <el-form-item
                    class="gcmcn-form-input radio-input"
                    v-if="userIsAtLeastAdmin || userIsEntityAdmin(entityUid)"
                >
                    <div class="gcmcn-form-label">
                        Choose default channel redundancy
                    </div>
                    <el-radio
                        v-model="form.channel_redundancy_type"
                        label="1+0"
                    >
                        1+0 (MAIN only)
                    </el-radio>
                    <el-radio
                        v-model="form.channel_redundancy_type"
                        label="1+1"
                    >
                        1+1 (MAIN+BACKUP)
                    </el-radio>
                </el-form-item>
                <el-form-item
                    v-if="userIsAtLeastAdmin || userIsEntityAdmin(entityUid)"
                    class="gcmcn-form-input checkbox-form-item"
                    prop="enable_thumbnail_generation"
                >
                    <el-checkbox
                        class="checkbox-input"
                        v-model="form.enable_thumbnail_generation"
                    >
                        <span class="gcmcn-form-label">Enable thumbnail generation</span>
                    </el-checkbox>
                </el-form-item>
                <el-form-item
                    class="gcmcn-form-input"
                    v-if="userIsAtLeastAdmin || userIsEntityAdmin(entityUid)"
                >
                    <div class="gcmcn-form-label">Maximum channel previews for this entity</div>
                    <el-input-number
                        v-model="form.max_running_previews"
                        :controls="false"
                        :min="1"
                        size="small"
                    ></el-input-number>
                </el-form-item>
                <el-form-item
                    class="gcmcn-form-input"
                    v-if="userIsAtLeastAdmin || userIsEntityAdmin(entityUid)"
                >
                    <div class="gcmcn-form-label">Choose channel preview duration (in seconds)</div>
                    <div class="gcmcn-form-label descr">Leave 0 for unlimited duration during broadcast</div>
                    <el-input-number
                        v-model="form.preview_duration_seconds"
                        :controls="false"
                        size="small"
                    ></el-input-number>
                </el-form-item>
                <el-row :gutter="0">
                    <el-col :span="12">
                        <el-form-item
                            class="gcmcn-form-input"
                            style="margin-bottom: 0;"
                            prop="logo"
                        >
                            <div class="gcmcn-form-label">Logo</div>
                            <upload-file
                                style="margin-top: 10px;"
                                :imageSize="{width: '58px', height: '58px'}"
                                :default-image="defaultLogo"
                                @image-uploaded="onCropLogo"
                            ></upload-file>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            class="gcmcn-form-input"
                            style="margin-bottom: 0;"
                            prop="image"
                        >
                            <div class="gcmcn-form-label">Image</div>
                            <upload-file
                                style="margin-top: 10px;"
                                :imageSize="{width: '104px', height: '29px'}"
                                :default-image="defaultImage"
                                @image-uploaded="onCropImage"
                            ></upload-file>
                        </el-form-item>
                    </el-col>
                </el-row>
                <div class="text-right">
                    <el-button
                        type="text"
                        @click="leave"
                    >Cancel</el-button>
                    <el-button
                        :loading="loading"
                        type="primary"
                        class="gcmcn-primary-btn small"
                        @click="validateForm">Save
                    </el-button>
                </div>
            </el-form>
        </div>
        <cropper-modal
            ref="cropper"
            :title="`Configure ${ cropType }`"
            @on-image-cropped="onImageCropped"
        >
            <ul class="crop-rules">
                <li
                    v-for="rule in cropRules"
                    :key="rule"
                >
                    {{ rule }}
                </li>
            </ul>
        </cropper-modal>
    </div>
</template>
<script>
import { UploadFile, CropperModal, } from 'gcmcn-common';
import { mapGetters } from 'vuex';
export default {

    components: {
        UploadFile,
        CropperModal,
    },

    props: {
        entity: {
            required: true,
            validator: prop => typeof prop === 'object' || prop === null
        },
    },

    data (){
        return {
            loading: false,
            form: {
                display_name: '',
                logo: '',
                image: '',
                max_latency_ms: 0,
                min_latency_ms: 0,
                channel_redundancy_type: '1+0',
                feed_redundancy_type: '1+1',
                preview_duration_seconds: 0,
                max_running_previews: 1,
                enable_thumbnail_generation: false,
                datacenter: null,
                aws_dispatch_region_uid: ''
            },
            defaultLogo: null,
            defaultImage: null,
            cropRules: [],
            cropType: '',
        };
    },

    computed: {
        ...mapGetters([
            'datacenters',
            'awsregions',
            'userIsAtLeastAdmin',
            'userIsEntityAdmin'
        ]),
        filteredDatacenters(){
            return this.datacenters.filter((datacenter) => datacenter.archived === false);
        },
        rules () {
            return {
                name: [{ required: true, validator: this.authorizedCharacters }],
                logo: [{ required: true }],
                image: [{ required: true }],
                aws_dispatch_region_uid: [{ required: true }],
            };
        },
        entityUid(){
            if(this.entity){
                return this.entity.uid;
            }
            return null;
        }
    },

    watch: {
        entity: {
            handler (){
                this.setForm();
            },
            deep: true,
            immediate: true,
        }
    },

    methods: {
        setForm (){
            if(this.entity){
                this.$set(this, 'form', JSON.parse(JSON.stringify(this.entity)));
                this.defaultImage = this.form.image;
                this.defaultLogo = this.form.logo;
                this.form.datacenter = this.form.datacenter_uid
            }else{
                let awsRegionDefaultValue = this.awsregions.find((region) => region.is_default === true);
                let awsRegionValue = null;
                if(awsRegionDefaultValue){
                    awsRegionValue = awsRegionDefaultValue;
                }
                this.$set(this, 'form', {
                    display_name: '',
                    logo: '',
                    image: '',
                    max_latency_ms: 0,
                    min_latency_ms: 0,
                    channel_redundancy_type: '1+0',
                    feed_redundancy_type: '1+1',
                    preview_duration_seconds: 0,
                    max_running_previews: 1,
                    enable_thumbnail_generation: false,
                    datacenter: null,
                    aws_dispatch_region_uid: awsRegionValue.uid,
                });
                this.defaultImage = null;
                this.defaultLogo = null;
            }
        },
        authorizedCharacters(rules, value, callback) {
            if(!this.form.display_name) {
                return callback(new Error('Name is required'));
            } else if (!this.form.display_name.match(this.$store.getters.authorizedCharactersRegex)) {
                return callback(new Error('Invalid name'));
            } else {
                callback();
            }
        },
        validateForm (){
            this.$refs.form.validate((valid) => {
                if(valid){
                    this.loading = true;
                    let form = JSON.parse(JSON.stringify(this.form));
                    let action;
                    let postData = { item: form, model: 'entities'};
                    let messageType = this.entity ? 'update' : 'create';
                    const logo = this.form.logo;
                    const image = this.form.image;
                    delete form.logo;
                    delete form.image;
                    if(this.entity){
                        action = 'patchItem';
                        if(typeof form.datacenter === 'object' && form.datacenter !== null){
                            form.datacenter_uid = form.datacenter.uid;
                        }else{
                            form.datacenter_uid = form.datacenter;
                        }
                        this.form.url = this.entity.url;
                    }else{
                        action = 'createItem';
                        form.name = form.display_name;
                        form.can_admin_users = [this.$store.getters.currentUser.uid];
                        form.datacenter_uid = form.datacenter;
                        postData.url = this.$store.state.api.meta.listModels.entities.url;
                    }
                    this.$store.dispatch(action, postData).then((res) => {
                        this.$message({
                            message: `Entity ${messageType}d!`,
                            type: 'success'
                        });
                        if(logo === '' || logo === null || image === '' || image === null){
                            return;
                        }
                        let fd = new FormData();
                        let fdHasData = false;
                        if(typeof(logo) !== 'string'){
                            fd.append('logo', logo);
                            fdHasData = true;
                        }
                        if(typeof(image) !== 'string'){
                            fd.append('image', image);
                            fdHasData = true;
                        }
                        if(fdHasData){
                            this.$store.dispatch('patchItemFormData', {
                                item: fd,
                                url: res.url,
                                model: 'entities',
                            }).then(() => {
                                this.$emit('on-entity-created');
                            }).catch((e) => {
                                this.loading = false;
                                console.error(e);
                            });
                        }else{
                            this.$emit('on-entity-created');
                        }
                    }).catch((e) => {
                        this.loading = false;
                        console.error(e);
                        this.$message.error(`Error on entity ${messageType === 'update' ? messageType : 'creation'}.`);
                    });
                }
            });
        },
        leave (){
            this.$emit('leave-form-view');
        },
        onCropImage (data){
            this.cropType = 'image';
            this.$set(this, 'cropRules', [
                'Image formats allowed are jpeg, jpg and png',
                'Best ratio 68:19',
                'Minimal image size allowed is 680 x 190'
            ]);
            this.$refs.cropper.open(data, {
                aspectRatio: 3.5789,
                minCropBoxWidth: 680,
                minCropBoxHeight: 190,
            });
        },
        onCropLogo (data){
            this.cropType = 'logo';
            this.$set(this, 'cropRules', [
                'Image formats allowed are jpeg, jpg and png',
                'Best ratio 1:1',
                'Minimal image size allowed is 10 x 10'
            ]);
            this.$refs.cropper.open(data, {
                aspectRatio: 1,
                minCropBoxWidth: 10,
                minCropBoxHeight: 10,
            });
        },
        async onImageCropped (croppedImage){
            const url = croppedImage;
            if(this.cropType === 'image'){
                this.defaultImage = croppedImage;
            }else{
                this.defaultLogo = croppedImage;
            }
            const file = await this.$store.dispatch('createBlobFromUrl', {imageUrl: url});
            if(this.cropType === 'image'){
                this.form.image = file;
            }else{
                this.form.logo = file;
            }
        },
    },
};
</script>

<style lang="scss">
.crop-rules{
    text-transform: initial;
    color: #bbb;
}
.inputs-container{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .flex-basis-5{
        flex-basis: calc( 50% - 10px);
    }
    .flex-basis-10{
        flex-basis: 100%;
    }
}
 .gcmcn-form-label.descr{
    color: #5e6064;
    margin: 0.5rem 0;
}
.radio-input{
    margin-bottom: 0;
}
.checkbox-form-item{
    margin-bottom: 0;
    .checkbox-input .el-checkbox__input .el-checkbox__inner{
        border: none;
        background-color: #444;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Entities/entity-form.vue